import React from "react";
import { Button, GridItem, useDisclosure } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import {
  AutoComplete,
  Form,
  Grid,
  Modal,
  NumberInput,
  Select,
  TextInput
} from "components";
import { DOSE_UNIT_OPTIONS, useToast } from "duck";
import { FormValues, getValidation } from "./duck";

interface CreateRegionalBlockProps {
  onSubmit(values: FormValues): Promise<any>;
  successToast: string;
  isProtocol?: boolean;
}

const CreateRegionalBlock: React.FC<CreateRegionalBlockProps> = ({
  onSubmit,
  successToast,
  isProtocol = false
}) => {
  const { onClose, onOpen, isOpen } = useDisclosure();

  const toast = useToast({
    status: "success",
    description: successToast
  });

  return (
    <>
      <Button onClick={onOpen} leftIcon={<IoAdd />}>
        Add
      </Button>

      <Modal title="Medication" onClose={onClose} isOpen={isOpen}>
        <Form<FormValues>
          {...getValidation()}
          onSubmit={values =>
            onSubmit(values).then(() => {
              onClose();
              toast();
            })
          }
        >
          {({ setValue, getValues, trigger }) => (
            <>
              <Grid py={6} templateColumns="repeat(2, 1fr)">
                <GridItem colSpan={2}>
                  <AutoComplete.Medications
                    creatable
                    name="name"
                    label="Name"
                    placeholder="Name"
                    optionValue="name"
                  />
                </GridItem>
                <GridItem>
                  <NumberInput
                    name="doseMin"
                    label="Dose Range"
                    placeholder="Dose Min"
                    min={0}
                    onBlur={() => {
                      setValue("doseMin", getValues("doseMin"), {
                        shouldTouch: true,
                        shouldValidate: true
                      });
                      trigger("doseMax");
                    }}
                  />
                </GridItem>
                <GridItem mt={8}>
                  <NumberInput
                    name="doseMax"
                    label="Dose Range"
                    labelHidden
                    placeholder="Dose Max"
                    min={0}
                    onBlur={() => {
                      setValue("doseMax", getValues("doseMax"), {
                        shouldTouch: true,
                        shouldValidate: true
                      });
                      trigger("doseMin");
                    }}
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <Select
                    name="doseUnit"
                    label="Dose Unit"
                    options={DOSE_UNIT_OPTIONS}
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <NumberInput
                    name="concentration"
                    label="Concentration"
                    placeholder="Concentration"
                    min={0}
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <NumberInput
                    name="volumeToBeInfused"
                    label="Volume to be infused"
                    placeholder="Volume to be infused"
                    min={0}
                  />
                </GridItem>
                {!isProtocol && (
                  <GridItem colSpan={2}>
                    <TextInput
                      label="Initials"
                      name="initials"
                      placeholder="Initials"
                    />
                  </GridItem>
                )}
              </Grid>
              <Form.Controls submitText="Add Medication">
                <Button variant="outline" colorScheme="gray" onClick={onClose}>
                  Cancel
                </Button>
              </Form.Controls>
            </>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default CreateRegionalBlock;
